import React, { useState, useCallback } from 'react';
import classnames from 'classnames';

import { Section, Layout, SEO } from '..';
import { questions } from './questions';

import style from './WebGamesFaqPage.module.less';

export const WebGamesFaqPage = () => {
  const [openQuestions, setOpenQuestions] = useState<{[key: string]: boolean}>({});

  const toggleQuestion = useCallback((i: number, j: number) => setOpenQuestions(state => ({
    ...state,
    [`${i}-${j}`]: !state[`${i}-${j}`]
  })), []);

  return (
    <Layout>
      <SEO title="FAQ" />

      <Section className={classnames(style.section, style.firstSection)}>
        <div className={style.content}>
          <h1>Frequently asked questions (Web Games)</h1>

          <div className={style.row}>
            <div className={style.text}>
              {questions.map((section, i) => (
                <div className={style.section} key={`section-${i}`}>
                  <h2>{section.header}</h2>
                  {section.questions.map(({ q, a }, j) => (
                    <div
                      className={classnames(style.question, openQuestions[`${i}-${j}`] ? style.open : style.closed)}
                    >
                      <div className={style.plusMinus} onClick={() => toggleQuestion(i, j)} />
                      <h3 onClick={() => toggleQuestion(i, j)}>{q}</h3>
                      <p>{a}</p>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Section>
    </Layout>
  );
};
